//Force encoding -> _Íì_ 
exports.getComposites = function() {
	return[
		{	"id" : 1
			,"name" : "1 plg de poliestireno (EPS) + Enjarre (zarpeo)"
			,"link" : "https://tecnopol.mx/portfolio/placa-aislante/"
			,"r_value" : 4.12
			,"u_value" : 1.3767
			,"thermal_resistance" : 0.7264
		},
		{	"id" : 2
			,"name" : "1 plg de poliestireno (EPS) + Fieltro papel permeable"
			,"link" : "https://tecnopol.mx/portfolio/placa-aislante/"
			,"r_value" : 4.07
			,"u_value" : 1.3955
			,"thermal_resistance" : 0.7166
		},
		{	"id" : 3
			,"name" : "1 plg de poliestireno (EPS) + Yeso"
			,"link" : "https://tecnopol.mx/portfolio/placa-aislante/"
			,"r_value" : 4.3
			,"u_value" : 1.3314
			,"thermal_resistance" : 0.7511
		},
		{	"id" : 4
			,"name" : "1 plg de poliestireno (EPS) de densidad = 10 kg/m3"
			,"link" : "https://tecnopol.mx/portfolio/placa-aislante/"
			,"r_value" : 3.36
			,"u_value" : 1.6909
			,"thermal_resistance" : 0.5914
		},
		{	"id" : 5
			,"name" : "1 plg de Poliestireno (EPS) de densidad = 12 kg/m3"
			,"link" : "https://tecnopol.mx/portfolio/placa-aislante/"
			,"r_value" : 3.63
			,"u_value" : 1.5657
			,"thermal_resistance" : 0.6387
		},
		{	"id" : 6
			,"name" : "1 plg de Poliestireno (EPS) de densidad= 16 kg/m3"
			,"link" : "https://tecnopol.mx/portfolio/placa-aislante/"
			,"r_value" : 4.01
			,"u_value" : 1.4154
			,"thermal_resistance" : 0.7065
		},
		{	"id" : 7
			,"name" : "1 plg de Poliestireno (EPS) de densidad= 28 kg/m3"
			,"link" : "https://tecnopol.mx/portfolio/placa-aislante/"
			,"r_value" : 4.43
			,"u_value" : 1.2816
			,"thermal_resistance" : 0.7803
		},
		{	"id" : 8
			,"name" : "2 plg de poliestireno (EPS) + Enjarre (zarpeo)"
			,"link" : "https://tecnopol.mx/portfolio/placa-aislante/"
			,"r_value" : 8.12
			,"u_value" : 0.6989
			,"thermal_resistance" : 1.4308
		},
		{	"id" : 9
			,"name" : "2 plg de poliestireno (EPS) + Fieltro papel permeable"
			,"link" : "https://tecnopol.mx/portfolio/placa-aislante/"
			,"r_value" : 8.08
			,"u_value" : 0.7032
			,"thermal_resistance" : 1.4221
		},
		{	"id" : 10
			,"name" : "2 plg de poliestireno (EPS) + Yeso"
			,"link" : "https://tecnopol.mx/portfolio/placa-aislante/"
			,"r_value" : 8.3
			,"u_value" : 0.6865
			,"thermal_resistance" : 1.4566
		},
		{	"id" : 11
			,"name" : "2 plg de poliestireno de densidad = 10 kg/m3"
			,"link" : "https://tecnopol.mx/portfolio/placa-aislante/"
			,"r_value" : 6.72
			,"u_value" : 0.8455
			,"thermal_resistance" : 1.1828
		},
		{	"id" : 12
			,"name" : "2 plg de poliestireno de densidad = 12 kg/m3"
			,"link" : "https://tecnopol.mx/portfolio/placa-aislante/"
			,"r_value" : 7.25
			,"u_value" : 0.7829
			,"thermal_resistance" : 1.2773
		},
		{	"id" : 13
			,"name" : "2 plg de poliestireno de densidad = 16 kg/m3"
			,"link" : "https://tecnopol.mx/portfolio/placa-aislante/"
			,"r_value" : 8.02
			,"u_value" : 0.7077
			,"thermal_resistance" : 1.4131
		},
		{	"id" : 14
			,"name" : "2 plg de poliestireno de densidad = 28 kg/m3"
			,"link" : "https://tecnopol.mx/portfolio/placa-aislante/"
			,"r_value" : 8.86
			,"u_value" : 0.6407
			,"thermal_resistance" : 1.5607
		},
		{	"id" : 15
			,"name" : "Mortero (1.5 cm)"
			,"link" : ""
			,"r_value" : 0.12
			,"u_value" : 48.0769
			,"thermal_resistance" : 0.0208
		},
		{	"id" : 16
			,"name" : "Yeso (1 cm)"
			,"link" : ""
			,"r_value" : 0.25844
			,"u_value" : 21.978
			,"thermal_resistance" : 0.0455
		},
		{	"id" : 17
			,"name" : "Teja de barro Ladrillera Mecanizada"
			,"link" : "https://ladrilleramecanizada.com/productos/tejas-de-barro"
			,"r_value" : 0.562888
			,"u_value" : 10.0908173562059
			,"thermal_resistance" : 0.0991
		},
		{	"id" : 18
			,"name" : "Foamular 1\""
			,"link" : ""
			,"r_value" : 5
			,"u_value" : 1.136
			,"thermal_resistance" : 0.880281690140845
		},
		{	"id" : 19
			,"name" : "Foamular 2\""
			,"link" : ""
			,"r_value" : 10
			,"u_value" : 0.568
			,"thermal_resistance" : 1.76056338028169
		}
	];
}
